export default __webpack_public_path__ + "static/media/kela_davis.5b91036e.jpg";